module.exports = __webpack_public_path__ + "static/fipcpurplefloralrabmain-795509dc6e0076a6ba99b35ef9795482.jpeg";